import React, { useState, useEffect } from "react"
import { Container, Input, Button, Row, Col, } from "reactstrap";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import { RiFileExcel2Line } from "react-icons/ri";

export function ApprovalConsiderationAnnounceSixComponent() {
    const user = JSON.parse(localStorage.getItem("userData"));
    const [listStartMonth, setListStartMonth] = useState([]);
    // console.log("listStartMonth", listStartMonth);
    const [listEndMonth, setListEndMonth] = useState([]);
    // console.log("listEndMonth", listEndMonth);
    const [startMonth, setStartMonth] = useState(0);
    // console.log("startMonth", startMonth);
    const [endMonth, setEndMonth] = useState(0);
    // console.log("endMonth", endMonth);
    const [listStartBudgetYear, setListStartBudgetYear] = useState([]);
    // console.log("listStartBudgetYear", listStartBudgetYear);
    const [listEndBudgetYear, setListEndBudgetYear] = useState([]);
    const [startBudgetYear, setStartBudgetYear] = useState(0);
    const [endBudgetYear, setEndBudgetYear] = useState(0);
    const [approvalResult, setApprovalResult] = useState([]);
    useEffect(() => {
        GetMonthMasterData();
        GetBudgetYear();
    }, [])

    useEffect(() => {
        async function GetApprovalAnnounceFour() {
            if (startMonth === 0 || endMonth === 0 || startBudgetYear === 0 || endBudgetYear === 0) {
                return;
            } else {
                let postData = new FormData();
                postData.append("startMonth", startMonth);
                postData.append("endMonth", endMonth);
                postData.append("startBudgetYear", startBudgetYear);
                postData.append("endBudgetYear", endBudgetYear);
                let res = await fetch("/api/ApprovalConsiderationResult/getApprovalAnnounceSix", {
                    method: "POST",
                    headers: {
                        "token": user.token
                    },
                    body: postData
                })
                let resJson = await res.json();
                setApprovalResult(resJson.dataenum);
            }
        }
        GetApprovalAnnounceFour();
    }, [startMonth, endMonth, startBudgetYear, endBudgetYear])

    async function GetMonthMasterData() {
        try {
            let res = await fetch("/api/MasterData/getMasterMonth")
            let resJson = await res.json();
            setListStartMonth(resJson.dataenum);
            setListEndMonth(resJson.dataenum);
        } catch (e) {
            // console.log(e);
        }
    }

    async function GetBudgetYear() {
        try {

            let res = await fetch("/api/MasterData/getBudgetYear")
            let resJson = await res.json();
            // console.log("year", resJson.dataenum);
            setListStartBudgetYear(resJson.dataenum);
            setListEndBudgetYear(resJson.dataenum);
        } catch (e) {
            // console.log(e);
        }
    }
    return (
        <Container>
            <div className="d-flex flex-wrap justify-content-center align-items-center mb-4">
                <div className="d-flex justify-content-center align-items-center">
                    <Input
                        type="select"
                        className={`rounded-pill rounded-end text-center input-color w-100`}
                        onChange={(e) => setStartMonth(e.target.value)}
                        value={startMonth}
                    >
                        <option value={0}>--เดือน--</option>
                        {listStartMonth.map(month => (
                            <option value={Number(month.monthNumber)}>{month.monthName}</option>
                        ))}

                    </Input>
                    <Input
                        type="select"
                        className="border border-1 rounded-pill rounded-start text-center input-color w-75"
                        onChange={(e) => setStartBudgetYear(e.target.value)}
                        value={startBudgetYear}
                    >
                        <option value={Number(0)}>--ปี--</option>
                        <option value={Number(2565)}>2565</option>
                        <option value={Number(2566)}>2566</option>
                        <option value={Number(2567)}>2567</option>
                        <option value={Number(2568)}>2568</option>
                        <option value={Number(2569)}>2569</option>
                        <option value={Number(2570)}>2570</option>
                        <option value={Number(2571)}>2571</option>
                        <option value={Number(2572)}>2572</option>
                    </Input>
                </div>
                <h5 className="mx-4">
                    ถึง
                </h5>
                <div className="d-flex justify-content-center align-items-center">
                    <Input
                        type="select"
                        className={`rounded-pill rounded-end text-center input-color w-100`}
                        onChange={(e) => setEndMonth(e.target.value)}
                        value={endMonth}
                    >
                        <option value={0}>--เดือน--</option>
                        {listEndMonth.map(month => (
                            <option value={Number(month.monthNumber)}>{month.monthName}</option>
                        ))}

                    </Input>
                    <Input
                        type="select"
                        className="border border-1 rounded-pill rounded-start text-center input-color w-75"
                        onChange={(e) => setEndBudgetYear(e.target.value)}
                        value={endBudgetYear}
                    >
                        <option value={0}>--ปี--</option>
                        <option value={2565}>2565</option>
                        <option value={2566}>2566</option>
                        <option value={2567}>2567</option>
                        <option value={2568}>2568</option>
                        <option value={2569}>2569</option>
                        <option value={2570}>2570</option>
                        <option value={2571}>2571</option>
                        <option value={2572}>2572</option>
                    </Input>
                </div>
            </div>
            <Row className='mb-3'>
                <Col className='d-flex justify-content-end'>
                    <Button
                        // disabled={firstYearSelected === "0" || secondYearSelected === "0" ? true : false}
                        className="btn border border-1 mx-1 btn-green"
                        href={`api/ApprovalConsiderationResult/exportApprovalAnnounceFour?startMonth=${startMonth}&endMonth=${endMonth}&startBudgetYear=${startBudgetYear}&endBudgetYear=${endBudgetYear}`}
                        download
                    >
                        <RiFileExcel2Line />
                        Export Excel
                    </Button>
                </Col>
            </Row>
            <div className="outer-wrapper">
                <div className="table-wrapper overflow-auto">
                    <table>
                        <thead>
                            <tr>
                                <th rowSpan="3">ลำดับ</th>
                                <th rowSpan="3">เลขที่คำขอ</th>
                                <th rowSpan="3">
                                    ชื่อผู้ขอรับเงินช่วยเหลือ หรืออุดหนุน
                                </th>
                                <th colspan="6">
                                    ผู้ประกอบกิจการส่งเงินสมทบเข้ากองทุนพัฒนาฝีมือแรงงาน
                                </th>
                                <th rowSpan="3">
                                    จำนวนเงิน ช่วยเหลือ หรืออุดหนุน (บาท)
                                </th>
                                <th rowSpan="3">
                                    วันที่จ่ายเงิน ช่วยเหลือหรือ อุดหนุน
                                </th>
                            </tr>
                            <tr>
                                <th colSpan="3">นำส่งเงินสมทบ</th>
                                <th colspan="3">
                                    พัฒนาฝีมือแรงงานครบตามสัดส่วนที่กฏหมายกำหนด
                                </th>
                            </tr>
                            <tr>
                                <th>ปี พ.ศ.</th>
                                <th>ว/ด/ป</th>
                                <th>จำนวนเงิน (บาท)</th>
                                <th>ปี พ.ศ.</th>
                                <th>จำนวนลูกจ้างเฉลี่ย (คน)</th>
                                <th>จำนวนลูกจ้างที่ได้รับการพัฒนา (คน)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {approvalResult.length > 0 ? approvalResult.map((item, i) => (
                                <>
                                    {item.detailLawOccupationReports.map((detail, index) => (
                                        <tr key={item.supportId + index}>
                                            {index === 0 && (
                                                <>
                                                    <td className="text-center" rowSpan={item.detailLawOccupationReports.length}>
                                                        {i + 1}
                                                    </td>
                                                    <td className="text-center" rowSpan={item.detailLawOccupationReports.length}>
                                                        {item.supportNo}
                                                    </td>
                                                    <td className="text-center" rowSpan={item.detailLawOccupationReports.length}>
                                                        {item.supportedName}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.year}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.passTest}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.lawOccupationName}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.testOccupationName}
                                                    </td>
                                                    <td className="text-center">
                                                        {NumberWithCommas(detail.personTotal)}
                                                    </td>
                                                    <td className="text-center" rowSpan={item.detailLawOccupationReports.length}>
                                                        {NumberWithCommas(item.paymentAmount)}
                                                    </td>
                                                    <td className="text-center" rowSpan={item.detailLawOccupationReports.length}>
                                                        {item.paymentDate}
                                                    </td>
                                                    <td className="text-center" rowSpan={item.detailLawOccupationReports.length}>
                                                        {item.paymentDate}
                                                    </td>
                                                </>
                                            )}
                                            {index >= 1 && (
                                                <>
                                                    <td className="text-center">
                                                        {detail.year}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.passTest}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.lawOccupationName}
                                                    </td>
                                                    <td className="text-center">
                                                        {detail.testOccupationName}
                                                    </td>
                                                    <td className="text-center">
                                                        {NumberWithCommas(detail.personTotal)}
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                    ))}
                                </>
                            )) : (
                                <tr>
                                    <td
                                        className="text-center"
                                        colSpan="11"
                                    >
                                        ไม่มีข้อมูล
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

        </Container>
    )
}